<template  >


    <v-container style="margin-top:60px;" >
        <v-card v-if="trades.length>0" class="mx-auto" dark style="background:transparent;" flat>
            <div style="text-align: center;">Trades</div>
            <v-card-text style="text-align: center;">
                Här visas dina mottagna och skickade bytesförslag
            </v-card-text>
            <div style="display:flex;">
                <v-spacer></v-spacer>
                <v-tabs v-model="trade_focus" center-active style="max-width:1000px !important;" centered>
                    <v-tab
                            v-for="(trade,index) in trades"
                            :key="index"
                    >
                        {{index+1}}
                    </v-tab>

                </v-tabs>
                <v-spacer></v-spacer>

            </div>


                <v-carousel :show-arrows="false" touchless v-model="trade_focus" height="900" hide-delimiters>
                    <v-carousel-item
                            v-for="(trade,index) in trades"
                            :key="index"
                    >

                            <Trade
                                    v-on:refresh="getTrades"
                                    :data=trade
                            >

                            </Trade>

                    </v-carousel-item>
                </v-carousel>








        </v-card>

        <v-card v-else class="mx-auto" dark style="background:transparent;" flat>
        <div style="text-align: center;">Trades</div>
        <v-card-text style="text-align: center;">
            Du har inga aktiva trades. Någon här under kanske vill byta?
        </v-card-text>
        <div style="display:flex;margin-top:50px;">
            <HicardsLeaderboard style="" :isDark=true :local=false></HicardsLeaderboard>

        </div>











        </v-card>



    </v-container>

</template>

<script>
    import Trade from  "../components/Trade"
    import HicardsLeaderboard from  "../components/HicardsLeaderboard"

    export default {
        name: "Trades",
        components:{Trade,HicardsLeaderboard},
        data:function(){
            return{
                trades:[],
                trade_focus:0


            }
        },
        methods:{






            getTrades:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;

                let url = '/api/get_my_trades';
                http.open('GET', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {//Call a function when the state changes.
                    if(http.readyState === 4 && http.status === 200){
                        let resp=JSON.parse(http.response);

                        self.trades=resp;

                    }};
                http.send();
            },

        },
        computed:{
        },
        watch:{
            '$store.state.APP.NEW_TRADES': function() {
                this.getTrades();
            }
        },
        mounted:function(){
            this.getTrades();

        }
    }



</script>

<style >

    .unverified{

        border: 2px solid #ffaa0075 !important;
    }

</style>
